var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgQuote2 = function SvgQuote2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.634 20c0-3.6-2.5-5.8-5.6-5.8-1 0-1.7.3-2 .5 0-4.5 2.8-9 7.6-9.9V.4c-5.9.8-13 5.9-13 17.2 0 5.5 3.2 8.3 6.8 8.3 3.6 0 6.2-2.7 6.2-5.9zm16 0c0-3.6-2.5-5.8-5.6-5.8-1 0-1.7.3-2 .5 0-4.5 2.8-9 7.6-9.9V.4c-5.9.8-13 5.9-13 17.2 0 5.5 3.2 8.3 6.8 8.3 3.6 0 6.2-2.7 6.2-5.9z",
    fill: "#000",
    fillOpacity: 0.15
  })));
};

export default SvgQuote2;